import { regClientResponse, regRoundResponse, regStepResponse } from "./Csi/csi.types";
import { api_107 } from "./1.07/rgs.107";
import { getCheatFromSelectedMode } from "./utils/utilsMethod";
import { getGameInstance, startGame } from "./Start";
import { Formatter } from "./utils/formatter";
import { allListener } from "./utils/listener";

export class api_107_base{
    public clientUid: any;
    public clientTokenForRequest: any;
    public rgs: api_107;

    protected gn_data: any = null;

    private coin : number = 0;
    private level : number = 0;
    private betMap: any = null;

    private isPossibleRefreshBalance = false //Mentre sei in partita non sarà possibile aggiornare il balance

    private game; 

    /**
     * Constructor
     * @param gameKey                Game Key
     * @param gameUID                Game UID
     * @param params                 Objects params
     * @param httpMonitorCallback    Monitoring Callback
     */
    constructor(gameKey: string, params: any, clientUID: any, clientTokenForRequest: any) {
        console.log("✅=^.^= Peppes Libs is connected successfullyy!");
        
        this.clientUid = clientUID;
        this.clientTokenForRequest = clientTokenForRequest;
        this.game = getGameInstance();

        // TODO: modificare per renderlo compatibile con la 1.06, 1.08 e la 2.00
        // NOTA: si utilizzano i primi 4 caratteri al fine di gestire eventuali versioni di test/sviluppo (ad esempio 1.07-DEV)
        // ! si dovrà inserire anche il supporto a 1.08
        switch (params.serverAPI.substr(0,4)) {
            //case "1.06":
            //    this.rgs = new rgs.api_106(gameKey, gameUID, params, httpMonitorCallback);
            //    break;
            case "1.07":
                this.rgs = new api_107(gameKey, params.game, params, this.game);
                break;
            //case "2.00":
            //    this.rgs = new rgs.api_107(gameKey, gameUID, params, httpMonitorCallback); 
            //    break;
            //case "1.08":
            //    this.rgs = new rgs.api_108(gameKey, gameUID, params, httpMonitorCallback);
            //    break;
            }
        
        if (this!.rgs == null) {
            throw new Error("RGS API Unavailable");
        }
        
        allListener(this.game, this);

    }
    
    public getCoin(): number {
        return this.coin;
    }

    public getLevel(): number {
        return this.level;
    }

    public setParams(clientUID: any, clientTokenForRequest: any, betMap: any){
        this.clientUid = clientUID;
        this.clientTokenForRequest = clientTokenForRequest;

        //è la prima betmap alla regClient
        this.betMap = betMap;
    }

    public getBetMap(){
        this.betMap[0].coins = this.coin;
        this.betMap[0].value = this.coin;
        this.betMap[0].total = (this.level * this.coin);
    }

    //Chiamata al motore di gioco
    public async regClient(params: any) : Promise<regClientResponse> {
        this.isPossibleRefreshBalance = false
        try {
            const sessionResponse = await this.rgs.getSessionAsync(params);

            const response = await this.rgs.regClientAsync(params);
            this.clientTokenForRequest = response.clientToken

            this.level = response.data.b[0].l;
            this.coin = response.data.b[0].c;

            (window as any).UIBridge?.setBetCoins(this.coin); 
            (window as any).UIBridge?.setCoinText((window as any).FORMATTER.formatCurrency(this.coin, true));
            (window as any).UIBridge?.setBet((window as any).FORMATTER.formatCurrency(this.level * this.coin, true)); 
            
            if((window as any).GENERAL_CONFIG.isFullscreenOn){
                (window as any).UIBridge?.fullscreenShow()
            }
          
            this.isPossibleRefreshBalance = true
            this.keepAliveStart();
            this.balancePingStart();
            return response;
        } catch (error) {
            const e = error instanceof Error ? error : new Error(String(error));

            console.error("❌ Errore in Caller.regClient:", e.message, e.stack);
            
            const payload = {
                m: e.message,
                stack: e.stack,
                clientUid: this.clientUid,
            };
            
            (window as any).UIBridge.showPopupControl(`popup.genericMessage`, true, (window as any).GENERAL_CONFIG.onlyRedirectToHomeOnNetworkError, false, true);
            
            await this.rgs.logEventAsync(32000, payload, null, this.clientUid, this.clientTokenForRequest);
            throw e;
        }
    }
    
    //Chiamata al motore di gioco
    public async regRound(mode: number, data?: object, bet?: any, cheat?: object): 
    Promise<regRoundResponse> {
        console.log("📞 CALLER.regRound chiamato!");
        this.isPossibleRefreshBalance = false
        this.getBetMap();
        bet = this.betMap;
    
        try {
            const response = await this.rgs.regRoundAsync(true, bet, this.gn_data, this.clientUid, this.clientTokenForRequest, cheat); //aggiungere enabledgambleround
            this.clientTokenForRequest = response.token
            console.log("✅ Risposta reg_round ricevuta:", response);
            return response;
        } catch (error) {
            const e = error instanceof Error ? error : new Error(String(error));
            console.error("❌ Errore in Caller.regRound:", error);
            const message = {
                m: e.message,
                stack: e.stack,
                clientUid: this.clientUid,
            };
            (window as any).UIBridge.showPopupControl(`popup.genericMessage`, true, (window as any).GENERAL_CONFIG.onlyRedirectToHomeOnNetworkError, false, true);
            await this.rgs.logEventAsync(32000, message, null, this.clientUid, this.clientTokenForRequest);
            throw e;
        }
    }
    
    //Chiamata al motore di gioco
    public async regStep(mode: number, data?: object, bet?: any, cheat?: object): 
    Promise<regStepResponse> {
        console.log("📞 CALLER.regStep chiamato!");

        this.isPossibleRefreshBalance = false
        cheat = getCheatFromSelectedMode()

        try {
            const response = await this.rgs.regStepAsync(mode, bet, data, this.gn_data, cheat, this.clientUid, this.clientTokenForRequest);
            
            cheat = undefined;
            (window as any).UIBridge?.resetCheat()
            
            this.clientTokenForRequest = response.token
            console.log("✅ Risposta reg_step ricevuta:", response);
            
            this.endStep();
    
            return response;
        } catch (error) {
            console.error("❌ Errore in Caller.regStep:", error);
            const e = error instanceof Error ? error : new Error(String(error));
            const message = {
                m: e.message,
                stack: e.stack,
                clientUid: this.clientUid,
            };
            (window as any).UIBridge.showPopupControl(`popup.genericMessage`, true, (window as any).GENERAL_CONFIG.onlyRedirectToHomeOnNetworkError, false, true);
            await this.rgs.logEventAsync(32000, message, null, this.clientUid, this.clientTokenForRequest)
            throw error;
        }
    }

    public async gameAnimationStart(): Promise<void> {
        console.log("🎬 gameAnimationStart nelle lib"); 
    }

    
    public async gameAnimationComplete(gameCanvas: HTMLCanvasElement): Promise<void> {
        // Se vuoi loggare:
        console.log("📞 CALLER.gameAnimationComplete chiamato!");
    
        // Dispatch degli eventi solo se il canvas è valido
        if (gameCanvas) {
            const event1 = new Event('gameAnimationComplete');
            gameCanvas.dispatchEvent(event1);
    
            const event2 = new Event('gcmGameAnimationComplete');
            gameCanvas.dispatchEvent(event2);
        }
        
        // Se hai bisogno di restituire qualcosa:
        return;
    }

    //Chiamata al motore di gioco
    public async endRound(){
        await this.rgs.endRound()
        this.isPossibleRefreshBalance = true
    }

    //Chiamata al motore di gioco
    public async endStep(){
        await this.rgs.endStep();
    }

    public async refreshBalance(){
        if(this.isPossibleRefreshBalance)
            await this.rgs.getDataAsync()
    }

    public keepAliveStart(){
        this.rgs.keepAlivePingStart();
    }

    public keepAliveStop(){
        this.rgs.keepAlivePingStop();
    }
    
    public balancePingStart(){
        this.rgs.requestBalancePingStart();
    }

    public balancePingStop(){
        this.rgs.requestBalancePingStop();
    }
}